import React, { useEffect, useState, useCallback } from "react";
import Table from "../../common/Table/table";
import { getAllReferralCommission, getAllReferralCommissionTotal } from "../../../store/slices/referralCommission.slice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TransactionModal from "./TransactionModal";

const ReferralCommission = () => {
  const {
    referralCommission,
    referralCommissionTotal,
    currentPage,
    totalPages,
    totalCount,
    isLoading,
  } = useSelector((state) => state.referralCommission);

  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const clinicId =clinicInfo?.[0]?.clinicId || null;

  // fetch wrapper with pagination & search support
  const fetchReferralCommission = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAllReferralCommission({
            clinicId,
            token,
            currentPage: page,
            limit: lim,
            searchQuery: search || undefined,
          })
        );
      }
    },
    [clinicId, token, dispatch, pageLimit, searchValue]
  );

  useEffect(() => {
    fetchReferralCommission();
  }, [fetchReferralCommission]);

  const tableHead = [
    { title: "Referrer Name", key: "referrerName" },
    { title: "Referrer Number", key: "referrerNumber" },
    { title: "Transaction", key: "transaction" },
  ];

  const handleSearch = (e) => {
    const searchQuery = e.target.value;
    setSearchValue(searchQuery);
    fetchReferralCommission(1, pageLimit, searchQuery);
  };

  const handlePageChange = (page) => {
    fetchReferralCommission(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchReferralCommission(1, newLimit, searchValue);
  };

  const redirectReferrerPaymentPage = (item) => {
    sessionStorage.setItem("id", item?.id);
    sessionStorage.setItem("referrerId", item?.referrerId);
    sessionStorage.setItem("referrerName", item?.referrerName);
    navigate("/referralCommissionPayment");
  };

  const openTransactionModal = (item) => {
    dispatch(
      getAllReferralCommissionTotal({
        clinicId,
        token,
        referralCommissionId: item?._id,
      })
    );
    setSelectedTransaction(item);
    setShowTransactionModal(true);
  };

  const closeTransactionModal = () => {
    setSelectedTransaction(null);
    setShowTransactionModal(false);
  };

  return (
    <>
      <Table
        tableHead={tableHead}
        tableBody={
          referralCommission &&
          referralCommission?.map((item) => ({
            id: item?._id,
            referrerName: item?.referrerId?.name,
            referrerId: item?.referrerId?._id,
            referrerNumber: item?.referrerId?.phone,
            transaction: (
              <button
                className="btn btn-primary"
                onClick={() => openTransactionModal(item)}
              >
                Transaction
              </button>
            ),
            clinicId: item?.clinicId?._id,
          }))
        }
        searchValue={searchValue}
        redirectReferrerPaymentPage={redirectReferrerPaymentPage}
        handleSearch={handleSearch}
        openTransactionModal={openTransactionModal}
        hideStatusTab={true}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        loading={isLoading}
        isLoading={isLoading}
      />
      <TransactionModal
        isOpen={showTransactionModal}
        onClose={closeTransactionModal}
        data={selectedTransaction}
        referralCommissionTotal={referralCommissionTotal}
      />
    </>
  );
};

export default ReferralCommission;